function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 78",
  transform: "translate(-465 -1718)"
}, /*#__PURE__*/React.createElement("circle", {
  "data-name": "Ellipse 36",
  cx: 25,
  cy: 25,
  r: 25,
  transform: "translate(465 1718)",
  fill: "#ed6a5a"
}), /*#__PURE__*/React.createElement("circle", {
  "data-name": "Ellipse 37",
  cx: 25,
  cy: 25,
  r: 25,
  transform: "translate(702 1718)",
  fill: "#ed6a5a"
}), /*#__PURE__*/React.createElement("circle", {
  "data-name": "Ellipse 38",
  cx: 25,
  cy: 25,
  r: 25,
  transform: "translate(544 1718)",
  fill: "#ed6a5a"
}), /*#__PURE__*/React.createElement("circle", {
  "data-name": "Ellipse 39",
  cx: 25,
  cy: 25,
  r: 25,
  transform: "translate(623 1718)",
  fill: "#ed6a5a"
}), /*#__PURE__*/React.createElement("circle", {
  "data-name": "Ellipse 40",
  cx: 25,
  cy: 25,
  r: 25,
  transform: "translate(781 1718)",
  fill: "#ed6a5a"
}), /*#__PURE__*/React.createElement("circle", {
  "data-name": "Ellipse 41",
  cx: 25,
  cy: 25,
  r: 25,
  transform: "translate(465 1798)",
  fill: "#ed6a5a"
}), /*#__PURE__*/React.createElement("circle", {
  "data-name": "Ellipse 42",
  cx: 25,
  cy: 25,
  r: 25,
  transform: "translate(702 1798)",
  fill: "#ed6a5a"
}), /*#__PURE__*/React.createElement("circle", {
  "data-name": "Ellipse 43",
  cx: 25,
  cy: 25,
  r: 25,
  transform: "translate(544 1798)",
  fill: "#ed6a5a"
}), /*#__PURE__*/React.createElement("circle", {
  "data-name": "Ellipse 44",
  cx: 25,
  cy: 25,
  r: 25,
  transform: "translate(623 1798)",
  fill: "#ed6a5a"
}), /*#__PURE__*/React.createElement("circle", {
  "data-name": "Ellipse 45",
  cx: 25,
  cy: 25,
  r: 25,
  transform: "translate(781 1798)",
  fill: "#ed6a5a"
}), /*#__PURE__*/React.createElement("circle", {
  "data-name": "Ellipse 46",
  cx: 25,
  cy: 25,
  r: 25,
  transform: "translate(465 1890)",
  fill: "#ed6a5a"
}), /*#__PURE__*/React.createElement("circle", {
  "data-name": "Ellipse 47",
  cx: 25,
  cy: 25,
  r: 25,
  transform: "translate(702 1890)",
  fill: "#ed6a5a"
}), /*#__PURE__*/React.createElement("circle", {
  "data-name": "Ellipse 48",
  cx: 25,
  cy: 25,
  r: 25,
  transform: "translate(544 1890)",
  fill: "#ed6a5a"
}), /*#__PURE__*/React.createElement("circle", {
  "data-name": "Ellipse 49",
  cx: 25,
  cy: 25,
  r: 25,
  transform: "translate(623 1890)",
  fill: "#ed6a5a"
}), /*#__PURE__*/React.createElement("circle", {
  "data-name": "Ellipse 50",
  cx: 25,
  cy: 25,
  r: 25,
  transform: "translate(781 1890)",
  fill: "#ed6a5a"
}), /*#__PURE__*/React.createElement("circle", {
  "data-name": "Ellipse 51",
  cx: 25,
  cy: 25,
  r: 25,
  transform: "translate(465 1970)",
  fill: "#d6d6d6"
}), /*#__PURE__*/React.createElement("circle", {
  "data-name": "Ellipse 52",
  cx: 25,
  cy: 25,
  r: 25,
  transform: "translate(702 1970)",
  fill: "#d6d6d6"
}), /*#__PURE__*/React.createElement("circle", {
  "data-name": "Ellipse 53",
  cx: 25,
  cy: 25,
  r: 25,
  transform: "translate(544 1970)",
  fill: "#d6d6d6"
}), /*#__PURE__*/React.createElement("circle", {
  "data-name": "Ellipse 54",
  cx: 25,
  cy: 25,
  r: 25,
  transform: "translate(623 1970)",
  fill: "#d6d6d6"
}), /*#__PURE__*/React.createElement("circle", {
  "data-name": "Ellipse 55",
  cx: 25,
  cy: 25,
  r: 25,
  transform: "translate(781 1970)",
  fill: "#d6d6d6"
}), /*#__PURE__*/React.createElement("circle", {
  "data-name": "Ellipse 56",
  cx: 32.5,
  cy: 32.5,
  r: 32.5,
  transform: "translate(527 2062)",
  fill: "#00a68d"
}), /*#__PURE__*/React.createElement("circle", {
  "data-name": "Ellipse 57",
  cx: 32.5,
  cy: 32.5,
  r: 32.5,
  transform: "translate(616 2062)",
  fill: "#00a68d"
}), /*#__PURE__*/React.createElement("circle", {
  "data-name": "Ellipse 58",
  cx: 32.5,
  cy: 32.5,
  r: 32.5,
  transform: "translate(705 2062)",
  fill: "#00a68d"
}));
var SvgOutOfRatio = function SvgOutOfRatio(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 366 409"
  }, props), _ref);
};
export default SvgOutOfRatio;